import {
  Grid, Hidden, List, ListItem, ListItemText, makeStyles, Menu, MenuItem, Typography,
  useMediaQuery, useTheme,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import FiltersContext from '../../contexts/FiltersContext';
import colors from '../../modules/colors';
import { rdsTabulate } from '../../modules/rds';
import { stateFIPS } from '../../modules/states';

function Filters() {
  const { stateCode } = useParams();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [currentMenu, setCurrentMenu] = React.useState(null);
  const {
    settingType, setSettingType, acceptSubsidies, setAcceptSubsidies,
    qualityRating, setQualityRating, displayBy,
  } = useContext(FiltersContext);
  const [ratings, setRatings] = useState([]);
  const [error, setError] = useState(null);
  const [ready, setReady] = useState(false);
  const [noQualityRatings, setNoQualityRatings] = useState(false);
  const theme = useTheme();
  const matchesSmall = useMediaQuery(theme.breakpoints.down('sm'));

  // const races = ['White', 'Black', 'Hispanic', 'Asian', 'AINA', 'NHPI', 'Multiracial', 'Other'];
  const classes = makeStyles((theme) => ({
    button: {
      backgroundColor: colors.blue,
      color: colors.white,
      borderRadius: 4,
      marginRight: theme.spacing(1),
      maxWidth: '25%',
      '&:hover': {
        backgroundColor: colors.lightBlue,
        boxShadow: 'none',
      },
      [theme.breakpoints.down('sm')]: {
        maxWidth: '35%',
      },
    },
  }))();

  useEffect(() => {
    setNoQualityRatings(false);

    rdsTabulate('ccdc', 'tract_licensed_capacity', {
      dims: 'qris_code',
      measure: 'COUNT:COUNT(*)',
      where: `(state_fips=${stateFIPS[stateCode.toUpperCase()]}) AND qris_participation=1`,
      orderby: 'qris_code ASC',
      inject: false,
      format: 'amcharts',
    }).then((result) => {
      const d = result.parsedBody.dataProvider;
      const ratingIds = d.map((v) => (v.qris_code));
      if (ratingIds.length === 0) {
        setNoQualityRatings(true);
        return;
      }

      axios.get(`${process.env.REACT_APP_RDS_SERVER}/api/catalog/ccdc/tract_licensed_capacity/classification/qris_code/codes?ids=${ratingIds.join(',')}`)
        .then((idsResponse) => {
          const codes = idsResponse.data;
          // console.log(codes);
          setRatings(codes);
        }).catch((getError) => {
          setError(getError);
        })
        .finally(() => {
          setReady(true);
        });
    })
      .catch((rdsError) => {
        setError(rdsError);
      });
  }, [stateCode]);

  const handleFilterClick = (menu) => (event) => {
    setAnchorEl(event.currentTarget);
    setCurrentMenu(menu);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChangeSettingType = (value) => () => {
    setSettingType(value);
    setCurrentMenu(null);
  };

  // const handleChangeChildRace = (value) => () => {
  //   setChildRace(value);
  //   setCurrentMenu(null);
  // };

  const handleChangeAcceptSubsidies = (value) => () => {
    setAcceptSubsidies(value);
    setCurrentMenu(null);
  };

  const handleChangeQualityRating = (value) => () => {
    setQualityRating(value);
    setCurrentMenu(null);
  };

  return (
    <>
      <Grid container direction="row" justify="center" alignItems="center">
        <Hidden smDown>
          <Grid item xs={12} md={2}>
            <Typography variant="body1" align="right" style={{ marginRight: 10 }}>Filter By:</Typography>
          </Grid>
        </Hidden>
        <Grid item xs={12} md={10}>
          <List
            component="nav"
            aria-label="Filters"
            style={{
              display: 'flex',
              flexDirection: 'row',
              padding: 0,
            }}
          >
            <ListItem
              className={classes.button}
              button
              dense
              aria-haspopup="true"
              aria-controls="lock-menu"
              onClick={handleFilterClick('settingTypeMenu')}
            >
              <ListItemText
                primary="Setting Type"
                secondary={(
                  <Typography style={{ color: '#fff' }} variant="caption">
                    {settingType}
                  </Typography>
                )}
              />
              <ExpandMoreIcon />
            </ListItem>
            <ListItem
              className={classes.button}
              button
              dense
              disabled={noQualityRatings}
              aria-haspopup="true"
              aria-controls="lock-menu"
              onClick={handleFilterClick('qualityRatingMenu')}
            >
              <ListItemText
                primary="Quality Rating"
                secondary={(
                  <Typography style={{ color: '#fff' }} variant="caption">
                    {noQualityRatings ? 'No state-level QRIS system.' : qualityRating.name}
                  </Typography>
                )}
              />
              <ExpandMoreIcon />
            </ListItem>
            <ListItem
              className={classes.button}
              button
              disabled={displayBy !== 'Providers'}
              dense
              aria-haspopup="true"
              aria-controls="lock-menu"
              onClick={handleFilterClick('acceptSubsidiesMenu')}
            >
              <ListItemText
                primary={matchesSmall ? 'Accept Subs...' : 'Accept Subsidies'}
                secondary={(
                  <Typography style={{ color: '#fff' }} variant="caption">
                    {acceptSubsidies}
                  </Typography>
                )}
              />
              <ExpandMoreIcon />
            </ListItem>
            {/* <ListItem
              className={classes.button}
              button
              dense
              aria-haspopup="true"
              aria-controls="lock-menu"
              onClick={handleFilterClick('childRaceMenu')}
            >
              <ListItemText
                primary="Child Race/Ethnicity"
                secondary={(
                  <Typography style={{ color: '#fff' }} variant="caption">
                    {childRace}
                  </Typography>
                )}
              />
              <ExpandMoreIcon />
            </ListItem> */}
          </List>
        </Grid>
      </Grid>

      <Menu id="settingTypeMenu" anchorEl={anchorEl} keepMounted open={currentMenu === 'settingTypeMenu' && Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem key="All" selected={settingType === 'All'} onClick={handleChangeSettingType('All')}>
          {settingType === 'All' ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}&nbsp;All
        </MenuItem>
        <MenuItem key="Center-based child care" selected={settingType === 'Center-based child care'} onClick={handleChangeSettingType('Center-based child care')}>
          {settingType === 'Center-based child care' ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}&nbsp;Center-based child care
        </MenuItem>
        <MenuItem key="Family child care (FCC)" selected={settingType === 'Family child care (FCC)'} onClick={handleChangeSettingType('Family child care (FCC)')}>
          {settingType === 'Family child care (FCC)' ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}&nbsp;Family child care (FCC)
        </MenuItem>
      </Menu>

      {/* <Menu id="childRaceMenu" anchorEl={anchorEl} keepMounted open={currentMenu === 'childRaceMenu' && Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem key="All" selected={childRace === 'All'} onClick={handleChangeChildRace('All')}>
          {childRace === 'All' ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}&nbsp;None
        </MenuItem>
        {races.map((r) => (
          <MenuItem key={r} selected={childRace === r} onClick={handleChangeChildRace(r)}>
            {childRace === r ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}&nbsp;{r}
          </MenuItem>
        ))}
      </Menu> */}

      <Menu id="acceptSubsidiesMenu" anchorEl={anchorEl} keepMounted open={currentMenu === 'acceptSubsidiesMenu' && Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem key="All" selected={acceptSubsidies === 'All'} onClick={handleChangeAcceptSubsidies('All')}>
          {acceptSubsidies === 'All' ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}&nbsp;All
        </MenuItem>
        <MenuItem key="Accept subsidies" selected={acceptSubsidies === 'Accept subsidies'} onClick={handleChangeAcceptSubsidies('Accept subsidies')}>
          {acceptSubsidies === 'Accept subsidies' ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}&nbsp;Accept subsidies
        </MenuItem>
        <MenuItem key="Do not accept subsidies" selected={acceptSubsidies === 'Do not accept subsidies'} onClick={handleChangeAcceptSubsidies('Do not accept subsidies')}>
          {acceptSubsidies === 'Do not accept subsidies' ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}&nbsp;Do not accept subsidies
        </MenuItem>
      </Menu>

      <Menu id="qualityRatingMenu" anchorEl={anchorEl} keepMounted open={currentMenu === 'qualityRatingMenu' && Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem key="All" selected={qualityRating.name === 'All'} onClick={handleChangeQualityRating({ name: 'All', codeValue: null })}>
          {qualityRating.name === 'All' ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}&nbsp;All
        </MenuItem>
        {ratings.map((r) => (
          <MenuItem key={r.codeValue} selected={qualityRating === r} onClick={handleChangeQualityRating(r)}>
            {qualityRating === r ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}&nbsp;{r.name}
          </MenuItem>
        ))}
        <MenuItem key="NR" selected={qualityRating.name === 'NR'} onClick={handleChangeQualityRating({ name: 'Quality Rating Not Reported', codeValue: 'NR' })}>
          {qualityRating.name === 'NR' ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}&nbsp;Quality Rating Not Reported
        </MenuItem>
        <MenuItem key="NP" selected={qualityRating.name === 'NP'} onClick={handleChangeQualityRating({ name: 'Not in Quality Rating Program', codeValue: 'NP' })}>
          {qualityRating.name === 'NP' ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}&nbsp;Not in Quality Rating Program
        </MenuItem>
      </Menu>
    </>
  );
}

export default Filters;
